import type { CategoryExecutor } from './executor.types';

export const executeCalculationsNode: CategoryExecutor = (node, context) => {
  const config = node.configuration ?? {};
  const formula = typeof config['formula'] === 'string' ? config['formula'] : undefined;
  const outputField = typeof config['outputField'] === 'string' ? config['outputField'] : undefined;
  const precision = typeof config['roundingPrecision'] === 'number' ? config['roundingPrecision'] : 2;

  if (!formula || !outputField) {
    // Many calculation nodes in packs use formula text; if missing, pass through.
    return { status: 'success', output: {} };
  }

  try {
    const result = context.expressions.evaluate(formula, context.payload);
    const value =
      typeof result === 'number' && Number.isFinite(result)
        ? Number(result.toFixed(precision))
        : result;
    return { status: 'success', output: { [outputField]: value } };
  } catch (error) {
    return {
      status: 'failure',
      message: error instanceof Error ? error.message : 'Formula evaluation failed',
      code: 'CALCULATION_FAILED',
    };
  }
};
